/* eslint-disable linebreak-style */

const DB_NAME = 'larex-webstore-cache';
const DB_VERSION = 1;
const LOOKUP_STORE = 'lookupCache';

let lookupDbPromise = null;
let resetChain = Promise.resolve();

const logDbWarning = (message, error)=>{
  // eslint-disable-next-line no-console
  console.warn(`[lookupDb] ${message}`, error || '');
};

const createDbConnection = ()=> new Promise((resolve, reject)=>{
  if (typeof indexedDB === 'undefined') {
    reject(new Error('IndexedDB indisponibil'));
    return;
  }

  const request = indexedDB.open(DB_NAME, DB_VERSION);

  request.onupgradeneeded = (event)=>{
    const db = event.target.result;
    if (!db.objectStoreNames.contains(LOOKUP_STORE)) {
      db.createObjectStore(LOOKUP_STORE, {keyPath: 'cacheKey'});
    }
  };

  request.onsuccess = ()=>{
    const db = request.result;
    db.onversionchange = ()=>{
      db.close();
      lookupDbPromise = null;
    };
    resolve(db);
  };

  request.onerror = ()=>{
    lookupDbPromise = null;
    reject(request.error || new Error('Nu am putut deschide IndexedDB'));
  };
});

export const openLookupDb = ()=>{
  if (!lookupDbPromise) {
    const generation = resetChain.then(()=> createDbConnection());
    lookupDbPromise = generation.catch((error)=>{
      if (lookupDbPromise === generation) {
        lookupDbPromise = null;
      }
      throw error;
    });
  }
  return lookupDbPromise;
};

const deleteLookupDatabase = ()=> new Promise((resolve)=>{
  if (typeof indexedDB === 'undefined') {
    resolve(false);
    return;
  }

  const request = indexedDB.deleteDatabase(DB_NAME);
  request.onsuccess = ()=> resolve(true);
  request.onerror = ()=>{
    logDbWarning('Nu am putut sterge IndexedDB', request.error);
    resolve(false);
  };
  request.onblocked = ()=>{
    logDbWarning('Stergerea IndexedDB este blocata de o conexiune deschisa');
  };
});

const clearStore = (db)=> new Promise((resolve, reject)=>{
  if (!db.objectStoreNames.contains(LOOKUP_STORE)) {
    resolve(false);
    return;
  }
  const tx = db.transaction(LOOKUP_STORE, 'readwrite');
  const request = tx.objectStore(LOOKUP_STORE).clear();
  request.onsuccess = ()=> resolve(true);
  request.onerror = ()=> reject(request.error || new Error('Nu am putut goli IndexedDB'));
});

/**
 * Goleste si sterge baza. Urmatorul open o recreeaza, iar logarea o umple din nou.
 */
export const clearLookupCache = ()=>{
  if (typeof indexedDB === 'undefined') {
    return Promise.resolve(false);
  }

  let releaseReset;
  const resetDone = new Promise((resolve)=>{
    releaseReset = resolve;
  });
  const previousReset = resetChain;
  resetChain = resetDone;

  const run = previousReset.then(async()=>{
    const pending = lookupDbPromise;
    lookupDbPromise = null;

    let db = null;
    if (pending) {
      try {
        db = await pending;
      } catch (error) {
        logDbWarning('Nu am putut deschide conexiunea existenta inainte de stergere', error);
      }
    }

    if (!db) {
      try {
        db = await createDbConnection();
      } catch (error) {
        logDbWarning('Nu am putut deschide IndexedDB pentru golire', error);
      }
    }

    if (db) {
      try {
        await clearStore(db);
      } catch (error) {
        logDbWarning('Nu am putut goli continutul IndexedDB', error);
      }
      db.close();
    }

    return deleteLookupDatabase();
  });

  run.finally(()=> releaseReset());
  return run;
};
